import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { OtpData, REG_EXP } from 'src/app/models/util.models';

@Component({
    selector: 'otp-input',
    templateUrl: './otp-input.component.html',
    styleUrls: ['./otp-input.component.css']
})
export class OtpInputComponent implements OnInit {

    reg_exp: REG_EXP = new REG_EXP();

    @Input('isPrimeNg')
    isPrimeNg: boolean = false;

    @Input('otp_data')
    otp_data: OtpData = new OtpData(0);

    @Output('otp_resend')
    otp_resend: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() { }

    async ngOnInit(): Promise<void> {
        this.init_countdown();
    }

    init_countdown() {
        this.otp_data.OTP_validate_api.can_resend = false;
        this.otp_data.OTP_validate_api.current_date = new Date();
        this.otp_data.OTP_validate_api.next_code = Math.round(
            (
                this.otp_data.OTP_validate_api.retry_after.getTime() -
                this.otp_data.OTP_validate_api.current_date.getTime()
            ) / 1000
        );

        this.timer(this.otp_data.OTP_validate_api.next_code);
    }

    otpResend() {
        this.otp_resend.emit(true);
    }

    timer(time_left: number): Promise<void> {
        let minutes = Math.floor(time_left / 60);
        let seconds = time_left % 60;
        let m = minutes < 10 ? '0' + minutes : minutes;
        let s = seconds < 10 ? '0' + seconds : seconds;
        this.otp_data.OTP_validate_api.countdown = m + ':' + s;
        time_left -= 1;
        if (time_left >= 0) {
            setTimeout(() => {
                this.timer(time_left);
            }, 1000);
            return;
        }
        this.otp_data.OTP_validate_api.can_resend = true;
    }

    only_number(event) {
        event = (event) ? event : window.event;
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
}
